import { UserAuthFormData } from '@/components/auth-page/user-auth-form'
import { Icons } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { useRouter } from 'next/navigation'
import { UseFormSetError } from 'react-hook-form'
import { toast } from 'sonner'
import { useScript, appleAuthHelpers } from 'react-apple-signin-auth'
import { useAppleLoginMutation } from '@/src/mutations/auth/apple-login'
import { usePostHogEvents, EVENTS } from '@/lib/posthog-events'

interface AppleResponse {
  authorization: {
    code: string
    id_token: string
    state: string
  }
  user?: {
    email: string
    name: {
      firstName: string
      lastName: string
    }
  }
}

export default function AppleLogin({
  setError,
}: {
  setError: UseFormSetError<UserAuthFormData>
}) {
  useScript(appleAuthHelpers.APPLE_SCRIPT_SRC)
  const appleLogin = useAppleLoginMutation()
  const router = useRouter()
  const { trackEvent } = usePostHogEvents()
  const handleAppleLogin = () => {
    appleAuthHelpers.signIn({
      authOptions: {
        clientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID!,
        redirectURI: process.env.NEXT_PUBLIC_FRONTEND_URI!,
        scope: 'email name',
        state: 'appleid-signin1-state',
        nonce: 'appleid-signin1-nonce',
        usePopup: true,
      },
      onSuccess(response: AppleResponse) {
        appleLogin.mutate(
          { id_token: response.authorization.id_token },
          {
            onSuccess() {
              toast.success('Logged in with Apple!')
              trackEvent(EVENTS.USER_LOGGED_IN, { provider: 'apple', method: 'oauth', flow: 'popup' })
              // router.push('/home')
            },
            onError(error) {
              setError('root', {
                type: 'manual',
                message: error.message,
              })
              toast.error(error.message)
            },
          }
        )
      },
      onError({ error }: { error: string }) {
        if (error !== 'popup_closed_by_user') {
          toast.error('Error while logging in with Apple')
          setError('root', {
            type: 'manual',
            message: 'Error while logging in with Apple',
          })
        }
      },
    })
  }
  return (
    <>
      <Button
        className="font-base flex-1 border border-gray bg-white text-black hover:bg-lightergray"
        onClick={handleAppleLogin}
        isLoading={appleLogin.isPending}
      >
        <Icons.Apple className="mr-2 h-5 w-5" />
        Continue with Apple
      </Button>
    </>
  )
}
